class StringHelper {
	static isNumeric(str) {
		return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
			!isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
	}

	static strtr(string, from, to) {
		let translationTable = {};

		for (let i = 0; i < from.length; i++) {
			translationTable[from.charAt(i)] = to.charAt(i) || '';
		}

		return string.replace(/./g, c => translationTable[c] || c);
	}
}

export default StringHelper;
